exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.content[data-v-0edbd57c] {\n  font-size: 0.25rem;\n  min-height: calc(100vh);\n}\n.content .tabbar[data-v-0edbd57c] {\n  position: fixed;\n  left: 0;\n  bottom: 0;\n  width: 100%;\n}\n.content .tabbar .weui-bar__item_on span[data-v-0edbd57c] {\n  color: #13227a;\n}\n.content .tabbar .weui-bar__item span[data-v-0edbd57c] {\n  color: #cdcdcd;\n}\n", ""]);

// exports
